import { get } from '../client';
import { B2B_API } from '../urls';

export type TranslationsDict = Record<string, string>;

export const fetchTranslations = async (
  locale: string,
  tenantId?: string,
): Promise<TranslationsDict> => {
  return get<TranslationsDict>(B2B_API.translations(locale), {
    headers: tenantId ? { 'X-TENANT-ID': tenantId } : undefined,
    auth: 'none',
    next: { revalidate: 600 },
  });
};
